import React, { useState, useEffect, useRef } from "react";
import "./slider.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";

const services = [
  {
    id: 1,
    title: "Web App Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
  {
    id: 2,
    title: "Mobile App Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
  {
    id: 3,
    title: "Blockchain Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
  {
    id: 4,
    title: "E-Commerce Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
  {
    id: 5,
    title: "AI / ML Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
  {
    id: 6,
    title: "Game Development",
    subtitle: "Software Company",
    description: "The Fastest Growing Software Company in the World.",
    image: "https://via.placeholder.com/300",
  },
];

function Slider() {
  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);
  const startX = useRef(0);
  const currentTranslate = useRef(0);
  const prevTranslate = useRef(0);
  const isDragging = useRef(false);
  const autoSlideInterval = useRef(null);

  const getPositionX = (event) => {
    return event.touches ? event.touches[0].clientX : event.clientX;
  };

  const handleDragStart = (e) => {
    isDragging.current = true;
    startX.current = getPositionX(e);
    sliderRef.current.style.transition = "none";
    clearInterval(autoSlideInterval.current);
  };

  const handleDragMove = (e) => {
    if (!isDragging.current) return;
    const currentX = getPositionX(e);
    const diff = currentX - startX.current;
    currentTranslate.current = prevTranslate.current + diff;
    sliderRef.current.style.transform = `translateX(${currentTranslate.current}px)`;
  };

  const handleDragEnd = () => {
    if (!isDragging.current) return;

    isDragging.current = false;
    sliderRef.current.style.transition = "transform 0.5s ease-in-out";

    if (currentTranslate.current - prevTranslate.current > 100) {
      setIndex((prev) => prev - 1);
    } else if (currentTranslate.current - prevTranslate.current < -100) {
      setIndex((prev) => prev + 1);
    }

    prevTranslate.current = -(index * sliderRef.current.offsetWidth);
    sliderRef.current.style.transform = `translateX(${prevTranslate.current}px)`;
    startX.current = 0;
    currentTranslate.current = 0;
    startAutoSlide();
  };

  useEffect(() => {
    const lastIndex = services.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index]);

  useEffect(() => {
    const slideWidth = sliderRef.current.offsetWidth;
    prevTranslate.current = -(index * slideWidth);
    sliderRef.current.style.transform = `translateX(${prevTranslate.current}px)`;
  }, [index]);

  const startAutoSlide = () => {
    autoSlideInterval.current = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);
  };

  useEffect(() => {
    startAutoSlide();

    const slider = sliderRef.current;
    slider.addEventListener("mousedown", handleDragStart);
    slider.addEventListener("mousemove", handleDragMove);
    slider.addEventListener("mouseup", handleDragEnd);
    slider.addEventListener("mouseleave", handleDragEnd);
    slider.addEventListener("touchstart", handleDragStart);
    slider.addEventListener("touchmove", handleDragMove);
    slider.addEventListener("touchend", handleDragEnd);

    return () => {
      clearInterval(autoSlideInterval.current);
      slider.removeEventListener("mousedown", handleDragStart);
      slider.removeEventListener("mousemove", handleDragMove);
      slider.removeEventListener("mouseup", handleDragEnd);
      slider.removeEventListener("mouseleave", handleDragEnd);
      slider.removeEventListener("touchstart", handleDragStart);
      slider.removeEventListener("touchmove", handleDragMove);
      slider.removeEventListener("touchend", handleDragEnd);
    };
  }, []);

  return (
    <section className="slider-container">
      <div className="slider" ref={sliderRef}>
        {services.map((service, serviceIndex) => {
          const { id, title, subtitle, description, image } = service;
          return (
            <article key={id} className="slide">
              <div className="slidercont">
                <h2>{title}</h2>
                <span>{subtitle}</span>
                <p>{description}</p>
                <a href="/contact" className="sliderbtn">
                  Contact Us
                </a>
              </div>
              <div className="sliderimage">
                <div className="col-lg-6">
                  <div className="banner-thumbnail">
                    <AnimationOnScroll
                      animateIn="zoomIn"
                      duration={2}
                      delay={300}
                      animateOnce={true}
                    >
                      <div className="large-thumb">
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/banner/window.png"
                          }
                          alt="Laptop"
                        />
                      </div>
                    </AnimationOnScroll>
                    <AnimationOnScroll
                      animateIn="slideInRight"
                      duration={2}
                      delay={300}
                      animateOnce={true}
                    >
                      <div className="large-thumb-2">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/banner/laptop-poses.png"
                          }
                          alt="Laptop"
                        />
                      </div>
                    </AnimationOnScroll>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Slider;
